/* Melissa Psychic Luxury Shopify Theme Pack
   Add this file before </body> in theme.liquid:
   <script src="{{ 'melissa-luxury.js' | asset_url }}" defer="defer"></script>
*/

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-mp-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mp-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
    });
  }

  document.querySelectorAll('[data-mp-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.mpFilter;
      const section = button.closest('.mp-section');
      const cards = section ? section.querySelectorAll('[data-mp-filter-tags]') : [];

      button.parentElement.querySelectorAll('[data-mp-filter]').forEach((chip) => {
        chip.classList.toggle('is-active', chip === button);
      });

      cards.forEach((card) => {
        const tags = card.dataset.mpFilterTags.split(' ');
        card.hidden = !(filter === 'all' || tags.includes(filter));
      });
    });
  });

  const revealItems = document.querySelectorAll('.mp-reveal');

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  revealItems.forEach((item) => observer.observe(item));
});
